import { ActionButton } from "../components/uploaded-files/custom-rows/ActionsRow";
import { Icons } from "../models/assets-files";
import { ActionsRowCta } from "../models/uploaded-file";
import { ImageService } from "../services/image.service";

export const uploadFilesTableActions: ActionButton[] = [
  {
    iconSrc: ImageService.getLocalIconPath(
      Icons.Folders.UPLOADED_FILES_ACTIONS,
      Icons.UploadedFilesActions.VIEW
    ),
    cta: ActionsRowCta.VIEW,
  },
  // {
  //   iconSrc: ImageService.getLocalIconPath(
  //     Icons.Folders.UPLOADED_FILES_ACTIONS,
  //     Icons.UploadedFilesActions.DELETE
  //   ),
  //   cta: ActionsRowCta.DELETE,
  // },
  {
    iconSrc: ImageService.getLocalIconPath(
      Icons.Folders.UPLOADED_FILES_ACTIONS,
      Icons.UploadedFilesActions.DOWNLOAD
    ),
    cta: ActionsRowCta.DOWNLOAD,
  },
];
